import { useTranslation } from 'react-i18next';
import { Income } from '../../participantEnums';

export const useIncomes = () => {
  const { t } = useTranslation('common');
  return [
    { value: Income.D0_D3, label: t('participants.enums.incomes.FR.D0_D3') },
    { value: Income.D3_D5, label: t('participants.enums.incomes.FR.D3_D5') },
    { value: Income.D5_D7, label: t('participants.enums.incomes.FR.D5_D7') },
    { value: Income.D7_D8, label: t('participants.enums.incomes.FR.D7_D8') },
    { value: Income.D8_D9, label: t('participants.enums.incomes.FR.D8_D9') },
    {
      value: Income.C90_C95,
      label: t('participants.enums.incomes.FR.C90_C95'),
    },
    {
      value: Income.C95_C98,
      label: t('participants.enums.incomes.FR.C95_C98'),
    },
    { value: Income.C98P, label: t('participants.enums.incomes.FR.C98P') },
  ];
};
